import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  configuracionEvento,
  resultadosEventoNew,
  detalleEvento,
  getPuntosControl,
  eventSubEvents,
} from "../../../data-store/actions/events-actions";

import ResultsReportNew from "../reports/ResultsReportNew";
import BuscadorResults from "../reports/BuscadorResults";
import { ResultadosGanadores, buildWinnersBoardData } from "../reports/reportsLogic";
import { buildSubclasificacionWinnersBoardData } from "../reports/subclasificacionesLogic";
import WinnersBoardCompact from "../reports/WinnersBoardCompact";
import CeremoniaPremiacion from "../reports/CeremoniaPremiacion";
import FullScreenDialog from "../Modals/FullScreenDialog";
import FormDialog from "../Modals/FormDialog";

import AppContainer from "../../../AppContainer";
import RealTimeResults from "../reports/RealTimeResults";
import RealTimeResultsFull from "../reports/RealTimeResultsFull";

import {
  Grid,
  Paper,
  Typography,
  LinearProgress,
  CardContent,
  CardActions,
  CardMedia,
  Box,
  Button,
} from "@material-ui/core";
import PuntosControlButtons from "./PuntosControlButtons";

// Material UI v4
const LiveEventShow = ({ match, hideAppContainer }) => {
  const dispatch = useDispatch();
  const EventoIndex = match?.params?.EventoIndex;

  // Redux state
  const evento = useSelector((state) =>
    state?.events?.events ? state.events.events[EventoIndex] : undefined
  );
  const eventDetail = useSelector((state) => state?.events?.eventDetail);
  const eventResults = useSelector((state) => state?.events?.eventResults);
  const eventConfiguration = useSelector(
    (state) => state?.events?.eventConfiguration
  );
  const puntosControl = useSelector((state) => state?.events?.puntosControl);
  const eventSubEventsState = useSelector((state) => state?.events?.eventSubEvents);

  // Local state
  const [isOpen, setIsOpen] = useState(false);
  const [controles, setControles] = useState(false);
  const [reportType, setReportType] = useState(0);

  // 👇 Punto de control seleccionado (por defecto "meta")
  const [selectedPuntoControl, setSelectedPuntoControl] = useState("meta");

  useEffect(() => {
    if (!EventoIndex) return;

    // En tu versión original se disparaba en mapDispatchToProps,
    // aquí lo hacemos en el mount.
    dispatch(detalleEvento(EventoIndex));
    dispatch(resultadosEventoNew(EventoIndex));
    dispatch(eventSubEvents(EventoIndex));
    dispatch(configuracionEvento(EventoIndex));
    dispatch(getPuntosControl(EventoIndex));
  }, [dispatch, EventoIndex]);

  // Si llegan puntosControl y el seleccionado no existe, fallback a "meta" o al primero.
  useEffect(() => {
    if (!puntosControl) return;

    const pcs = normalizePuntosControl(puntosControl);
    const exists = pcs.some((p) => p?.key === selectedPuntoControl);

    if (!exists) {
      const hasMeta = pcs.some((p) => p?.key === "meta");
      setSelectedPuntoControl(hasMeta ? "meta" : (pcs[0]?.key ?? "meta"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [puntosControl]);

  const openResultsReport = useCallback((e, tipo) => {
    e.preventDefault();
    setReportType(tipo);
    setIsOpen((v) => !v);
  }, []);

  const toggleResultsReport = useCallback(() => {
    setIsOpen((v) => !v);
  }, []);

  // Botones barra superior
  const BarButtons = useMemo(() => {
    return [
      <FormDialog
        key="search-mini"
        buttomLabel={"search"}
        ShowIcon={true}
        ButtonStyle={null}
        maxWidthProp={"sm"}
        report={<BuscadorResults icon={false} />}
      />,
    ];
  }, []);

  const numberAndNameFinder = useMemo(() => {
    return (
      <FormDialog
        key="search-full"
        buttomLabel={"Buscar por nombre ó Número"}
        ShowIcon={false}
        ButtonStyle={null}
        maxWidthProp={"sm"}
        style={{ minHeight: "40vh" }}
        report={<BuscadorResults icon={false} />}
      />
    );
  }, []);

  // Normalizamos puntosControl para poder pintar botones sin importar si viene array u objeto
  const puntosControlList = useMemo(() => {
    return normalizePuntosControl(puntosControl);
  }, [puntosControl]);

  const WinnersButton = useMemo(() => {
    return (
      <FullScreenDialog
        buttomLabel={"Resultados Preliminares de Ganadores"}
        title={"Resultados Preliminares de Ganadores"}
        report={
          <ResultsReportNew
            reportResultType={4}
            controles={controles}
            puntosControl={puntosControl}
            // 👇 por si lo soportas dentro del reporte
            selectedPuntoControl={selectedPuntoControl}
          />
        }
        BarButtons={BarButtons}
      />
    );
  }, [BarButtons, controles, puntosControl, selectedPuntoControl]);

  const subclasificaciones = useMemo(
    () =>
      (eventConfiguration &&
        eventConfiguration.timingConfig &&
        eventConfiguration.timingConfig.subclasificaciones) ||
      {},
    [eventConfiguration]
  );

  const winnersBoardData = useMemo(() => {
    if (!eventResults || !eventSubEventsState) return [];
    return buildWinnersBoardData(
      ResultadosGanadores(eventResults),
      eventSubEventsState
    ).concat(buildSubclasificacionWinnersBoardData(eventResults, subclasificaciones, eventSubEventsState));
  }, [eventResults, eventSubEventsState, subclasificaciones]);

  const WinnersBoardButton = useMemo(() => {
    return (
      <FullScreenDialog
        buttomLabel={"Ver ganadores (resumen)"}
        title={"Resumen de Ganadores"}
        report={
          <WinnersBoardCompact
            modalidadGroups={winnersBoardData}
            tituloEvento={eventDetail && eventDetail.nombreEvento}
          />
        }
      />
    );
  }, [winnersBoardData, eventDetail]);

  const CeremoniaPremiacionButton = useMemo(() => {
    return (
      <FullScreenDialog
        buttomLabel={"Ceremonia premiación"}
        title={"Ceremonia de Premiación"}
        report={
          <CeremoniaPremiacion
            modalidadGroups={winnersBoardData}
            tituloEvento={eventDetail && eventDetail.nombreEvento}
          />
        }
      />
    );
  }, [winnersBoardData, eventDetail]);

  // Contenido principal
  if (evento === undefined) {

    return (

      <AppContainer hide={hideAppContainer}>
        <LinearProgress />
      </AppContainer>
    );
  }

  const finalistasCount =
    eventResults?.filter((a) => a?.to !== "00:00:00")?.length ?? 0;
  console.log("hideAppContainer", hideAppContainer)
  return (

    <AppContainer hide={hideAppContainer}>
      <Grid container direction="row">
        {/* Header evento */}
        <Grid item xs={12} sm={12}>
          <Paper style={{ margin: 20 }}>
            <Grid container direction="row">
              <Grid item xs={12} sm={3}>
                <CardMedia
                  component="img"
                  alt={"Logo evento:" + evento.nombreEvento}
                  height="auto"
                  image={evento.logoEvento}
                  title={"Logo evento:" + evento.nombreEvento}
                />
              </Grid>

              <Grid item xs={12} sm={9}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    {evento.nombreEvento} (PRELIMINARES)
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    EVENTO EN PROCESO
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {evento.lugarEvento}, {evento.ciudadEvento}, {evento.paisEvento}
                  </Typography>
                </CardContent>

                <CardActions>
                  {WinnersButton}
                  {WinnersBoardButton}
                  {CeremoniaPremiacionButton}
                  {numberAndNameFinder}
                </CardActions>
              </Grid>
            </Grid>
          </Paper>
        </Grid>


        {/* Resumen finalistas */}
        <Grid item xs={12} sm={12}>
          {eventDetail && eventResults && (
            <Paper style={{ padding: 10, margin: 10, backgroundColor: "#e0e0e0" }}>
              <Typography color="primary" variant={"h1"} align="center">
                {finalistasCount}
              </Typography>
              <Typography variant={"h5"} align="center">
                Finalistas de {eventResults.length} atletas participando
              </Typography>

            </Paper>
          )}
        </Grid>



        {/* Tiempo real */}
        <Grid item xs={12} sm={12}>
          {eventDetail && eventResults && puntosControl && eventSubEventsState && !eventSubEventsState["modalidad_1"].nonStop && (
            <Paper>
              <RealTimeResultsFull
                eventDetail={eventDetail}
                eventResults={eventResults}
                puntosControl={puntosControl}
                eventSubEvents={eventSubEventsState}
                hideClock={false}
                numberOfRows={10}
              />
            </Paper>
          )}
          {eventDetail && eventResults && puntosControl && eventSubEventsState && eventSubEventsState["modalidad_1"].nonStop && (
            <Paper>
              <RealTimeResults
                eventDetail={eventDetail}
                eventResults={eventResults}
                puntosControl={puntosControl}
                eventSubEvents={eventSubEventsState}
                hideClock={false}
                numberOfRows={1000}
                nonStop={true}
              />
            </Paper>
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
};

/**
 * Normaliza puntosControl a un array:
 * - Si ya es array, lo usa.
 * - Si es objeto, convierte keys a [{key,label,data}]
 * - Garantiza que exista "meta" al inicio si viene.
 */
function normalizePuntosControl(puntosControl) {
  if (!puntosControl || typeof puntosControl !== "object") return [];

  const list = Object.keys(puntosControl).map((key) => {
    const pc = puntosControl[key] || {};
    const order = typeof pc.kNroPunto === "number" ? pc.kNroPunto : 999;

    // Label principal para el botón
    const label =
      pc.descripcionFinalPunto ||
      pc?.modalidadesPuntoDeControl?.modalidad_1?.laps?.lap_1?.descripcionPunto ||
      key;

    return {
      key,              // "kPC_0", "kPC_1", etc (esto es lo que vas a guardar en selectedPuntoControl)
      label,            // "Meta del evento", "SALIDA", "CONTROL en RUTA"
      order,            // kNroPunto
      data: pc,         // todo el objeto para usos avanzados
    };
  });

  // Ordenar por kNroPunto
  list.sort((a, b) => (a.order ?? 999) - (b.order ?? 999));

  return list;
}

export default LiveEventShow;
